import { Box, Typography } from "@mui/material";
import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import { ExternalLink } from "ExternalLink";
import { ReactComponent as HelpCircleIcon } from "components/Icons/help-circle.svg";
import { ReactComponent as Link03Icon } from "components/Icons/link-03.svg";
import { OLTheme } from "contexts/Theme/ThemeProvider";
import { useMessage } from "hooks/intl";
import { ReactElement } from "react";
import { Tooltip } from "./Tooltip";

const useStyles = makeStyles((theme: OLTheme) =>
  createStyles({
    tooltipTitle: {
      fontSize: "14px",
      fontWeight: 500,
      lineHeight: "24px",
      color: theme.gray800,
    },
    tooltipText: {
      whiteSpace: "break-spaces",
      marginTop: theme.spacing(2),
      fontSize: "12px",
      lineHeight: "20px",
      fontWeight: 400,
    },
    tooltipLinks: {
      display: "flex",
      gap: theme.spacing(4),
      marginTop: theme.spacing(6),
      width: "100%",
    },
    tooltipIcon: {
      backgroundColor: "initial !important",
      color: `${theme.gray500} !important`,
      height: "16px !important",
      opacity: 0.5,
      width: "16px !important",
    },
    linkWrapper: {
      maxWidth: "100%",
      "& > span": {
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
      },
    },
    icon: {
      width: "14px",
      height: "14px",
      flexShrink: 0,
    },
  }),
);

interface Props {
  externalLink?: string;
  name?: string;
  text?: string | ReactElement;
}

export function ExternalLinkTooltipContent({
  externalLink,
  name,
  text,
}: Props) {
  const classes = useStyles();
  const { message } = useMessage();

  return (
    <>
      {name && (
        <Typography className={classes.tooltipTitle}>
          {message({ id: name })}
        </Typography>
      )}
      {text && <Typography className={classes.tooltipText}>{text}</Typography>}
      {externalLink && (
        <Box className={classes.tooltipLinks}>
          <ExternalLink
            endIcon={<Link03Icon className={classes.icon} />}
            path={externalLink}
            data-test-id={`${name}-tab-tooltip-external-link`}
            className={classes.linkWrapper}
          >
            <span>{message({ id: "documentation" })}</span>
          </ExternalLink>
        </Box>
      )}
    </>
  );
}
export function ExternalLinkTooltip({ externalLink, name, text }: Props) {
  const classes = useStyles();

  return (
    <Tooltip
      data-test-id={`${name}-tab-tooltip`}
      text={
        <ExternalLinkTooltipContent
          externalLink={externalLink}
          name={name}
          text={text}
        />
      }
    >
      <HelpCircleIcon className={classes.tooltipIcon} />
    </Tooltip>
  );
}
